import { Col, ProgressStepper, Row } from '@snsw-gel/react';
import {
  StyledHeadingContainer,
  StyledServiceTitle,
  StyledHeading,
  StyledContentContainer,
} from './EventLayout.styled';

interface EventLayoutProps {
  children: React.ReactNode;
  currentStep?: number;
  showStepper?: boolean;
  title?: string;
}

const STEP_LABELS = ['Personal details', 'Business details', 'Review and submit'];

const buildStepsList = (currentStep: number) => {
  return STEP_LABELS.map((label, index) => ({
    content: label,
    status: (index + 1 < currentStep ? 'completed' : index + 1 === currentStep ? 'current' : 'todo') as
      | 'completed'
      | 'current'
      | 'todo',
  }));
};

const EventLayout: React.FC<EventLayoutProps> = ({
  children,
  currentStep,
  showStepper = true,
  title = 'Register for an event',
}) => {
  return (
    <>
      <StyledHeadingContainer>
        <Row>
          <Col>
            <StyledServiceTitle>Small Business Advisory Event</StyledServiceTitle>
            {showStepper && currentStep !== undefined && (
              <ProgressStepper stepsList={buildStepsList(currentStep)} className="" />
            )}
            {!showStepper && <StyledHeading level={1}>{title}</StyledHeading>}
          </Col>
        </Row>
      </StyledHeadingContainer>
      <StyledContentContainer>
        <Row>
          <Col>{children}</Col>
        </Row>
      </StyledContentContainer>
    </>
  );
};

export default EventLayout;
